import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex);

import CONSTANT from '@/services/Constant.js';
const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const store = new Vuex.Store({

    state: {
        isAuthenticated: !!localStorage.getItem(CONSTANT.LOCAL_STORAGE.TOKEN),
        token: localStorage.getItem(CONSTANT.LOCAL_STORAGE.TOKEN),
        loginUser: localStorage.getItem(CONSTANT.LOCAL_STORAGE.LOGIN_USER),
        loginUserEmail: "",
        alert: {
            isAlertSuccess: false,
            isAlertInfo: false,
            isAlertWarn: false,
            isAlertError: false,
            alertSuccessMessage : 'Success!',
            alertInfoMessage : 'Info!',
            alertWarnMessage : 'Warn!',
            alertErrorMessage : 'Error!'
        }
    },
    mutations: {
        [LOGIN_SUCCESS](state, user) {
            state.isAuthenticated = true;
            state.loginUserEmail = user.email;
            state.loginUser = user;
        },
        isAuthenticated: (state, value) => {
            state.isAuthenticated = value;
        },
        setAlert: (state, value) => {

            state.alert.isAlertSuccess = (value.isAlertSuccess)? value.isAlertSuccess : false;
            state.alert.isAlertError = (value.isAlertError)? value.isAlertError : false;
            state.alert.isAlertInfo = (value.isAlertInfo)? value.isAlertInfo : false;
            state.alert.isAlertWarn = (value.isAlertWarn)? value.isAlertWarn : false;

            state.alert.alertSuccessMessage = (value.isAlertSuccess)? 'Success! ' + value.message : 'Success!';
            state.alert.alertErrorMessage = (value.isAlertError)? 'Error! ' + value.message : 'Error!';

            setTimeout(() => {
                state.alert.isAlertSuccess = false;
                state.alert.isAlertError = false;
                state.alert.isAlertInfo = false;
                state.alert.isAlertWarn = false;
            }, 5000);
        }
    },
    getters: {
        isAuthenticated: state => state.isAuthenticated,
        token: state => state.token,
        loginUser: state => state.loginUser,
        loginUserEmail: state => state.loginUserEmail,
        alert: state => state.alert
    }
});